import { ReactNode, useEffect, useState } from 'react'

import { useToastContext } from '../contexts/ToastContext'
import ResponseError from '../../models/ResponseError'

interface ToastOnceProps {
    error: Error | undefined
}
// Toast the same message just once regardless if the error flickers to undefined.
export default function ToastOnce(props: ToastOnceProps) {
    const [error, setError] = useState<Error>()
    const Toast = useToastContext()

    useEffect(() => {
        if (!props.error) return
        if (props.error?.message !== error?.message) setError(props.error)
    }, [props.error])

    useEffect(() => {
        if (error instanceof ResponseError) Toast.error(error, error.title)
        else if (error instanceof Error) Toast.error(error)
    }, [error])

    return undefined as ReactNode
}
